import { Component, effect, inject, NgZone, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { DynamicScriptLoaderService } from '../../../services/dynamicScriptLoader.service';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

import { signal, computed } from '@angular/core';
import { BookingSummaryCardComponent } from '../booking-summary-card/booking-summary-card.component';
import { BookingConfigService } from '../../services/booking-config.service';
import { CheckoutServices } from '../../services/checkout.service';
import { BookingPriceService } from '../../services/booking-price.service';
import { HandleBookingService } from '../../services/handle-booking.service';
import { ParkingRepo } from '../../repo/parking.repo';
import { FormService } from '../../organizations/features/booking/components/form/service';
import { FormGroup } from '@angular/forms';
import { OrderStatusModalComponent } from '../order-status-modal/order-status-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TopNavbarComponent } from '../../organizations/components/top-navbar/top-navbar.component';
import { MatIconModule } from '@angular/material/icon';
import { CartService } from '../../services/cart.service';

declare var payex: any;
@Component({
  selector: 'app-payment',
  imports: [
    TranslocoModule,
    BookingSummaryCardComponent,
    OrderStatusModalComponent,
    TopNavbarComponent,
    MatIconModule
],
  templateUrl: './payment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './payment.component.scss'
})
export class GeneralPaymentComponent implements OnInit {
  orderId: string = '';
  booking: any = {};
  parkingOrder: any = null;
  site: string = '';
  payexCreditcardUrl = '';
  payexSwishUrl = '';
  payexCreditcardLoaded = false;
  payexSwishLoaded = false;
  selectedPayment: string | null = null;
  componentDestroyed$: Subject<boolean> = new Subject();
  @ViewChild('swishCheckbox') swishCheckbox!: CheckboxComponent;
  @ViewChild('swedbankCheckbox') swedbankCheckbox!: CheckboxComponent;
  locale = 'sv';

  orderSignal = signal<null | any>(null);
  bookingSignal = signal<null | any>(null);
  hasErrorSignal = signal(false);

  arrivalParkingOptions = [
    { value: '', viewValue: '' },
  ];
  bookingDetails: any = {
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  activeLang: string = 'sv';
  email: string;
  bookingNumber: any;
  pricingService: BookingPriceService;
  parkingFrom !: any;
  form !: FormService
  details !: FormGroup;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  additionalServices: any;
  handleBookingGroup: any;

  isBookingLoaded = computed(
    () => this.orderSignal() && this.bookingSignal()
  );

  targetTime: number = 0;
  countdown: number = 0;
  timerInterval: any;
  payexUrl = '';

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public checkoutService: CheckoutServices,
    public dynamicScriptLoaderService: DynamicScriptLoaderService,
    public translocoService: TranslocoService,
    private bookingConfigService: BookingConfigService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private handleBookingService: HandleBookingService,
    private parkingRepo: ParkingRepo,
    private _formService: FormService,
    public dialog: MatDialog,
    private cartService: CartService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;

    if (this.site == 'quality hotel arlanda xpo parkering' || this.site == 'quality-xpo-arlanda' || this.site == 'quality') {
      this.site = 'quality';
    }

    if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
      this.site = "aiden"
    }

    handleBookingService.initForm(this.site);
    this._formService.initForm(this.site);
    this.pricingService = inject(BookingPriceService);
    this.form = this._formService;
    this.details = this.form.getForm().get('details');
    this.parkingGroup = this.form.getForm().get('parkingGroup');
    this.departureHotel = this.form.departureHotel || this.form.getForm().get('hotels')?.controls?.departureHotel?.value;
    this.arrivalHotel = this.form.arrivalHotel || this.form.getForm().get('hotels')?.controls?.arrivalHotel?.value;
    this.handleBookingGroup = handleBookingService.getForm().get('details');

    effect(() => {
      if (this.isBookingLoaded() && (!this.payexCreditcardLoaded || !this.payexSwishLoaded)) {
        if (this.bookingDetails.order && this.bookingDetails.order.status == 'Checkout') {
          this.startTimer();
        }
        this.loadScripts(this.orderSignal().paymentReference);
      } else {
        this.resetTimer();
      }
    });
  }

  toggleSwish() {
    this.selectedPayment == 'swish' ? this.selectedPayment = null : this.selectedPayment = 'swish';
  }
  toggleCredit() {
    this.selectedPayment == 'credit' ? this.selectedPayment = null : this.selectedPayment = 'credit';
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.bookingConfigService.setOrganizationFromUrl();
      this.site = this.bookingConfigService.getConfig().site;
    });

    this.activatedRoute.params.pipe(takeUntil(this.componentDestroyed$)).subscribe({
      next: (params) => {
        this.orderId = params['orderId'];
        this.getOrder();
      },
      error: (err) => {
        this.hasErrorSignal.set(true);
      },
      complete: () => {
      }
    });
  }

  getOrder() {
    this.checkoutService.getOrder(this.orderId).subscribe(order => {
      this.orderSignal.set(order);
      this.bookingDetails.order = order;

      this.email = order?.customer?.email;
      this.bookingNumber = order?.orderNr;

      if (this.email && this.bookingNumber) {
        this.handleBookingService.getBookingDetails(this.email, this.bookingNumber).subscribe(
          {
            next: ((bookingDetails) => {

              this.site = bookingDetails.organizationName?.toLowerCase();
              if (this.site == "flygets.se" || this.site == "ving") {
                this.site = "flygets";
              }

              if (this.site == 'quality hotel arlanda xpo parkering' || this.site == 'quality-xpo-arlanda' || this.site == 'quality') {
                this.site = 'quality';
              }

              if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.site = "aiden"
              }

              if (bookingDetails.orderStatus == "Paid") {
                this.router.navigate([`parkifly/${this.site}/checkout/receipt/${this.orderId}/NONE`]);
              }

              if (bookingDetails.orderStatus == "Cancelled") {
                this.openConfirmModal();
              }

              this.orderId = bookingDetails.orderId;
              this.booking = bookingDetails;

              this.handleBookingService.getForm().get('details').controls['cellular']?.setValue(bookingDetails.cellular ?? '');
              this.handleBookingService.getForm().get('details').controls['regNr']?.setValue(bookingDetails.carRegNumber ?? '');
              this.handleBookingService.getForm().get('details').controls['email']?.setValue(bookingDetails.email ?? '');
              this.handleBookingService.getForm().get('details').controls['email']?.disable();
              if (this.site === 'skavsta') {
                this.handleBookingService.getForm().get('details').controls['firstname']?.setValue(bookingDetails.firstName ?? '');
                this.handleBookingService.getForm().get('details').controls['firstname']?.disable();
                this.handleBookingService.getForm().get('details').controls['lastname']?.setValue(bookingDetails.lastName ?? '');
                this.handleBookingService.getForm().get('details').controls['lastname']?.disable();
                this.handleBookingService.getForm().get('details').controls['persons']?.setValue(bookingDetails?.passengers?.toString());
                this.booking.parkingShuttleFrom = bookingDetails.parkingFrom;
                this.booking.parkingShuttleTo = bookingDetails.parkingTo;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'flygets') {
                this.handleBookingService.getForm().get('details').controls['comment']?.setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact']?.setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons']?.setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking']?.setValue(currentParkingTime);
                const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
                  ? bookingDetails.additionalServices.filter((e: any) => (e.status != 'Cancelled' && e.status != 'Removed'))
                  : [];
                if (additionalServicesArray.length > 0) {
                  additionalServicesArray.forEach(function (element: any, index: any) {
                    if (typeof element.name === 'string') {
                      element.name = JSON.parse(element.name);
                    }
                    if (typeof element.description === 'string') {
                      element.description = JSON.parse(element.description);
                    }
                    if (element.amount && element.vatAmount) {
                      element.amount = element.amount + element.vatAmount;
                    }
                  });
                }
                this.bookingDetails.additionalServices = additionalServicesArray;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'mdpark') {
                this.handleBookingService.getForm().get('details').controls['comment']?.setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact']?.setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons']?.setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking']?.setValue(currentParkingTime);
              }
            }),
            error: (err: any) => {
              this.hasErrorSignal.set(true);
            },
            complete: () => {
              this.bookingSignal.set(true);
            }
          }
        );
      } else {
        this.hasErrorSignal.set(true);
      }
    });
  }

  openConfirmModal() {
    const dialogRef = this.dialog.open(OrderStatusModalComponent, {
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/start']);
      }
    });
  }

  private loadScripts(paymentReference: any) {

    paymentReference = JSON.parse(paymentReference);

    const cardModal = document.getElementById('swedbank-pay-seamless-view-page');
    if (cardModal) {
      cardModal.innerHTML = ''; cardModal
    }
    const viewCheckoutOp = paymentReference.operations.find(
      (op) => op.rel === 'view-checkout'
    );
    this.payexUrl = viewCheckoutOp?.href;
    this.dynamicScriptLoaderService.addScript(this.payexUrl);

    this.dynamicScriptLoaderService
      .load(this.payexUrl)
      .then(() => {
        payex.hostedView
          .checkout({
            container: 'swedbank-pay-seamless-view-page',
            onPaymentCompleted: (event: any) => {
              this.ngZone.run(() => {
                this.resetTimer();
                this.router.navigate([`parkifly/${this.site}/checkout/receipt/${this.orderId}/NONE`]);
              });
            },
            onPaymentCancelled: (event: any) => {
              this.ngZone.run(() => {
                this.selectedPayment = null;
              });
            }
          })
          .open();

        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);
      })
      .catch(error => console.error(error));
  }

  // Timer
  startTimer() {
    const now = Date.now();
    this.targetTime = now + 15 * 60 * 1000;
    this.timerInterval = setInterval(() => {
      const now = Date.now();
      this.countdown = Math.max(0, Math.floor((this.targetTime - now) / 1000));
      if (this.countdown <= 0) {
        clearInterval(this.timerInterval);
        this.expireSession();
      }
    }, 1000);
  }

  resetTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.countdown = 0;
    this.targetTime = 0;
  }

  expireSession() {
    this.selectedPayment = null;
    this._formService.paymentReference = null;
    if (navigator.onLine && this.orderId) {
      this.cancelOrder();
    } else {
      window.addEventListener('online', this.retryCancelOrder);
    }
    this.router.navigate(['parkifly', this.site]);
  }

  formatTime(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  cancelOrder() {
    this.cartService.abortorder(this.orderId).subscribe({
      next: (result) => {
        if (result == true) {
          this.orderId = null;
          this._formService.paymentReference = null;
        }
      },
      error: (err) => {
        console.error('Error occurred while fetching order details:', err);
      },
      complete: () => {
      }
    });
  }

  retryCancelOrder = () => {
    if (this.orderId) {
      setTimeout(() => {
        this.cancelOrder();
        window.removeEventListener('online', this.retryCancelOrder);
      }, 5000);
    }
  };

}